import {baseURL} from '@/infrastructure/Configuration'
import SessionApi from "@/mixins/Services/SessionApi";

const COMPANY = 'admin/company';

export default {
    mixins: [SessionApi],
    methods: {
        async getCompanies() {
            const url = `${baseURL}${COMPANY}`
            const response = await this.httpSession().get(url)
            console.debug('[COMPANY][getCompanies] RESPONSE', response.data)
            return response.data;
        },
        async getCompany(companyId) {
            console.debug('[COMPANY][getCompany] request companyId', companyId)
            const url = `${baseURL}${COMPANY}`
            const response = await this.httpSession().get(url, {params: {companyId}})
            console.debug('[COMPANY][getCompany] RESPONSE', response.data)
            return response.data;
        },

        async createCompany(data) {
            console.debug('[COMPANY][createCompany] request data', data)
            const url = `${baseURL}${COMPANY}`
            const response = await this.httpSession().post(url, {...data})
            console.debug('[COMPANY][createCompany] RESPONSE', response.data)
            return response.data
        },

        async updateCompany(data) {
            console.debug('[COMPANY][updateCompany] request data', data)
            const url = `${baseURL}${COMPANY}/${data.companyId}`
            const response = await this.httpSession().put(url, {...data})
            console.debug('[COMPANY][updateCompany] RESPONSE', response.data)
            return response.data
        },

        async deleteCompany(companyId) {
            console.debug('[COMPANY][deleteCompany] request companyId', companyId)
            const url = `${baseURL}${COMPANY}/${companyId}`
            const response = await this.httpSession().delete(url, {params: {companyId}})
            console.debug('[COMPANY][deleteCompany] RESPONSE', response.data)
            return response.data
        }
    },
};

